import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { DepartmentSearch } from "../../models/Department/DepartmentSearch";
import {
  CodeBookPagedFilter,
  HierarchicalCodeBook,
  HierarchicalCodeBookPagedFilter,
  SaveResult,
  OibServiceResult,
} from "../../models/Shared";
import { Department } from "./../../models/Department/Department";
import { DepartmentCreateRequest } from "./../../models/Department/DepartmentCreateRequest";
import { DepartmentEditRequest } from "./../../models/Department/DepartmentEditRequest";
import { DepartmentListSearch } from "./../../models/Department/DepartmentListSearch";

const apiUrlPrefix: string = "department";

export const getDepartmentFilteredList = async (
  departmentListSearch: DepartmentListSearch
) => {
  return api.post(`${apiUrlPrefix}/search`, departmentListSearch) as Promise<
    PagedResult<Department>
  >;
};

export const createDepartment = async (
  departmentCreateRequest: DepartmentCreateRequest
) => {
  return api.post(`${apiUrlPrefix}`, departmentCreateRequest) as Promise<
    SaveResult<DepartmentCreateRequest>
  >;
};

export const editDepartment = async (
  departmentEditRequest: DepartmentEditRequest
) => {
  return api.put(`${apiUrlPrefix}`, departmentEditRequest) as Promise<
    SaveResult<DepartmentEditRequest>
  >;
};

export const deleteDepartment = async (id: number) => {
  return api.delete(`${apiUrlPrefix}/${id}`) as Promise<SaveResult<string>>;
};

export const searchDepartment = async (search: DepartmentSearch) => {
  return api.post(`${apiUrlPrefix}/search`, search) as Promise<
    PagedResult<Department>
  >;
};
